import {SpeakerInvitationDaySlot} from "../../../model/SpeakerInvitationCreateMessage";
import {ParticipationType} from "../../../model/ParticipationType";
import React from "react";
import {Box, Stack, Tag} from "@mbank-design/design-system/components";

export interface SelectedSlotsProps {
    slots: SpeakerInvitationDaySlot[],
    participationType: ParticipationType | undefined
    isDayValid: boolean
}

export default function SelectedSlots({slots, participationType, isDayValid}: SelectedSlotsProps) {
    
    const checkedSlots = slots.filter(s => s.checked);
    const plusDays = checkedSlots.length - 2;
    
    return (
        <span className={"with-gap-4"}>
            {!isDayValid && (
                <Tag backgroundColor={"red30"}>please choose any time range or skip the day</Tag>
            )}
            
            {participationType === ParticipationType.OnSite && (
                <Tag>in person</Tag>
            )}
            
            {participationType === ParticipationType.Remote && (
                <Tag>virtually</Tag>
            )}

            {participationType === ParticipationType.NotParticipate && (
                <Tag backgroundColor={"doveGrayUI"}>skip</Tag>
            )}

            {checkedSlots.slice(0,2).map(s => 
                <Tag key={s.uiId}>{s.timeFrom.substring(0,5)}-{s.timeTo.substring(0,5)}</Tag>
            )}

            {plusDays > 0 && <Tag>+{plusDays}</Tag>}
            
        </span>
    );
}